<template>
    <div
        class="info-banner"
        :class="`info-banner--${props.severity}`"
        v-bind="$attrs"
    >
        <slot />
    </div>
</template>

<script setup lang="ts">
type InfoBannerSeverity = 'info' | 'warning' | 'error';

defineOptions({
    inheritAttrs: false,
});

const props = withDefaults(defineProps<{
    severity?: InfoBannerSeverity;
}>(), {
    severity: 'info',
});
</script>

<style lang="scss" scoped>
.info-banner {
    padding: var(--smallSpacing) var(--defaultSpacing);
    color: var(--primaryFont);

    &--info {
        border-left: 3px solid var(--lcpBlue);
        background-color: var(--lcpBlueHover);
    }

    &--warning {
        border-left: 3px solid var(--warningYellow);
        background-color: color-mix(in srgb, var(--warningYellow) 20%, transparent);
    }

    &--error {
        border-left: 3px solid var(--dangerRed);
        background-color: color-mix(in srgb, var(--dangerRed) 20%, transparent);
    }
}
</style>
